import { RealEstateDto } from "api/real-estate";
import { RealEstateFormValues } from "../types/realEstateFormValues";
import { PossibleAnswer } from "features/subscription-process/profiling-process/types/interfaces";
import { RealEstateFormFieldNames } from "../types/realEstateFormFieldNames";

export function mapRealEstate<T extends RealEstateFormValues>(
  realEstateCommand: RealEstateDto,
  surveyForm?: Record<string, PossibleAnswer>,
  existingPhoto?: File
): T {
  const address = realEstateCommand.address;
  const baseFormValues = {
    // Address fields
    address: address.line1 || '',
    additionalAddress: address.line2 || "",
    postalCode: address.zipCode || '',
    city: address.city || '',
    country: address.country || '',

    [RealEstateFormFieldNames.Id]: realEstateCommand.id,
    [RealEstateFormFieldNames.Name]: realEstateCommand.name,
    [RealEstateFormFieldNames.Area]: realEstateCommand.area,
    [RealEstateFormFieldNames.RoomCount]: realEstateCommand.roomCount,
    [RealEstateFormFieldNames.MonthlyRent]: realEstateCommand.rentAmount,
    [RealEstateFormFieldNames.Charges]: realEstateCommand.charges,
    [RealEstateFormFieldNames.RentalType]: realEstateCommand.rentalType,
    [RealEstateFormFieldNames.PropertyType]: realEstateCommand.propertyType,
    [RealEstateFormFieldNames.SurveyForm]: surveyForm,
    [RealEstateFormFieldNames.Photo]: existingPhoto
  };

  return baseFormValues as T;
}
